module.exports = __webpack_public_path__ + "static/DarksideDetective6-705eef0e490b8b32465571a048493569.webp";